/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6ebb401ca2bb96d312f9fbe451c346b187e8121b";
